<template>
  <div class="toolbar">
    <img
      class="left-icon"
      @click="onClickLeftIcon"
      :src="leftIconSrc"/>
    {{title}}
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import hamburgerButtonImage from '@/assets/hamburger-button.svg'
import backButtonImage from '@/assets/back-button.svg'

export default defineComponent({
  name: 'Toolbar',
  props: {
    title: String,
    iconType: {
      validator: function (value: string) {
        return ['none', 'menu', 'back'].indexOf(value) !== -1
      }
    }
  },
  methods: {
    onClickLeftIcon (e: Event) {
      this.$emit('onClickLeftIcon', e)
    }
  },
  computed: {
    leftIconSrc () {
      if (this.iconType === 'menu') {
        return hamburgerButtonImage
      } else if (this.iconType === 'back') {
        return backButtonImage
      }
      return null
    }
  }
})
</script>

<style scoped lang="scss">
  .toolbar {
    width: 100vw;
    height: 64px;
    background: #decc8e;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #191919;
    font-weight: 500;
    font-size: 24px;
    font-family: NotoSansCJKtc;
    position: relative;
    .left-icon[src] {
      display: block;
      position: absolute;
      left: 36px;
      height: 48px;
      width: 48px;
      object-position: center;
      object-fit: none;
      cursor: pointer;
    }
    .left-icon {
      display: none;
    }
  }
</style>
